module.exports = __webpack_public_path__ + "img/part5-22.b3028a6a.png";